import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';

/**
 * Checkbox — native checkbox with label + Populus styling.
 * Phase 11 Block 6 PR 2.
 */

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
  description?: ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, description, style, id, ...rest },
  ref,
) {
  const inputId = id || `cb-${Math.random().toString(36).slice(2, 8)}`;
  return (
    <label
      htmlFor={inputId}
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'var(--sp-2)',
        cursor: rest.disabled ? 'not-allowed' : 'pointer',
        opacity: rest.disabled ? 0.6 : 1,
        ...style,
      }}
    >
      <input
        ref={ref}
        type="checkbox"
        id={inputId}
        style={{
          width: 16,
          height: 16,
          marginTop: 1,
          accentColor: 'var(--brand-primary)',
          cursor: 'inherit',
        }}
        {...rest}
      />
      <span>
        <span style={{
          display: 'block',
          fontSize: 'var(--fs-md)',
          color: 'var(--color-ink)',
        }}>{label}</span>
        {description && (
          <span style={{
            display: 'block',
            fontSize: 'var(--fs-sm)',
            color: 'var(--color-ink-3)',
            marginTop: 'var(--sp-0-5)',
          }}>{description}</span>
        )}
      </span>
    </label>
  );
});
